import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles/tailwind.css";

import CategoryPage from "pages/CategoryPage.jsx";
import OrdersPage from "pages/OrdersPage.jsx";
import OrderExpress from "pages/OrderExpress.jsx";
import MainLayout from "layouts/MainLayout";
import Dashboard from "pages/Dashboard.jsx";
import OrdersReview from "pages/OrdersReview.jsx";
import OrderDetailPage from "pages/OrderDetailPage.jsx";
import OrderHistory from "pages/OrderHistory";
import Checkout from "pages/Checkout";
import ProductDetail from "pages/ProductDetail";
import OrderConfirmation from "pages/OrderConfirmation";
import RegisterRequest from "pages/RegisterRequest";
import OrdersCxP from "pages/OrdersCxP.jsx";

// layouts
import Login from "views/auth/Login";

// views without layouts
import Profile from "views/Profile.js";
import ProfileUsers from "views/profile/ProfileUsers.jsx";
import ProfileUsersCreate from "views/profile/ProfileUsersCreate.jsx";
import BudgetManagement from "views/profile/BudgetManagement.jsx";
import ProfileCompany from "views/profile/ProfileCompany";
import ProfilePersonal from "views/profile/ProfilePersonal";
import Index from "views/Index.js";

// ⭐ CONTEXTOS
import { UserProvider } from "./context/UserContext";
import { CartProvider } from "./context/CartContext";
import { OrderExpressProvider } from "./context/OrderExpressContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ImageViewerProvider } from "./context/ImageViewerContext";

ReactDOM.render(
  <LanguageProvider>
    <ImageViewerProvider>
      <CartProvider>     {/* ⭐ ENVOLVER CARRO */}
        <UserProvider>   {/* ⭐ ENVOLVER USUARIO */}
          <OrderExpressProvider> {/* ENVOLVER ORDER EXPRESS */}
            <BrowserRouter>
              <MainLayout>
                <Switch>
                  <Route path="/dashboard" exact component={Dashboard} />
                  <Route path="/orders-review" exact component={OrdersReview} />
                  <Route path="/orders-history" exact component={OrderHistory} />
                  <Route path="/profile" exact component={Profile} />
                  <Route path="/login" exact component={Login} />
                  <Route path="/categoria/:categoryId">
                    <CategoryPage />
                  </Route>
                  <Route path="/orders" exact component={OrdersPage} />
                  <Route path="/order-express" exact component={OrderExpress} />
                  <Route path="/proforma-express" exact render={({ history }) => { history.replace("/order-express?mode=proforma"); return null; }} />
                  <Route path="/order-details/:orderId" exact component={OrderDetailPage} />
                  <Route path="/checkout" exact component={Checkout} />
                  <Route path="/order-confirmation" exact component={OrderConfirmation} />
                  <Route path="/product/:productId" component={ProductDetail} />
                  <Route path="/register" component={RegisterRequest} />
                  <Route path="/profile/users" exact component={ProfileUsers} />
                  <Route path="/profile/users/create/:id?" component={ProfileUsersCreate} />
                  <Route path="/profile/budget" exact component={BudgetManagement} />
                  <Route path="/profile/ProfileCompany" exact component={ProfileCompany} />
                  <Route path="/profile/personal" component={ProfilePersonal} />
                  <Route path="/orders-cxp" component={OrdersCxP} />
                  <Route path="/" exact component={Index} />
                  <Route path="*">
                    <div style={{ padding: 40 }}>404 - Not Found</div>
                  </Route>
                </Switch>
              </MainLayout>
            </BrowserRouter>
          </OrderExpressProvider>
        </UserProvider>
      </CartProvider>
    </ImageViewerProvider>
  </LanguageProvider>,
  document.getElementById("root")
);
